import { defineStore } from 'pinia'

import { createQualityComplaintsActions } from './actions'
import { createQualityComplaintsState } from './state'

export const useQualityComplaintsStore = defineStore('qualityComplaints', () => {
    const state = createQualityComplaintsState()
    const actions = createQualityComplaintsActions(state)

    return {
        ...state,
        ...actions
    }
})
